import React from "react";
import classNames from "classnames";
import "./OpticksCard.css";
import OpticksIconArea from "../OpticksIconsComponents/OpticksIconArea/OpticksIconArea";

interface Props {
  icon: React.ReactNode;
  onClick: () => void;
  selected?: boolean;
  recommended?: boolean;
  title: string;
  subtitle?: string;
  description: React.ReactNode;
  /**
   * Renders the card as a radio option. The consumer is responsible for
   * wrapping the set in an element with `role="radiogroup"`.
   */
  asRadio?: boolean;
  disabled?: boolean;
}

const OpticksCard = ({
  icon,
  onClick,
  selected,
  recommended,
  title,
  subtitle,
  description,
  asRadio = false,
  disabled = false,
}: Props) => {
  const handleActivate = () => {
    if (disabled) return;
    onClick();
  };

  return (
    <div
      role={asRadio ? "radio" : "button"}
      aria-checked={asRadio ? Boolean(selected) : undefined}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      className={classNames("opticks-card", {
        selected: selected,
        disabled: disabled,
      })}
      onClick={handleActivate}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleActivate();
        }
      }}
    >
      {recommended && (
        <b className="opticks-card-recommended-badge">Recommended</b>
      )}
      <OpticksIconArea icon={icon} />
      <div className="opticks-card-title-description">
        <h6 className="opticks-card-title">
          {title}
          {subtitle && (
            <>
              <br />
              {subtitle}
            </>
          )}
        </h6>
        <p className="opticks-card-description">{description}</p>
      </div>
    </div>
  );
};

export default OpticksCard;
